/**
 * Newsletter URL builders
 *
 * Now uses the shared millaAuth utility for URL building.
 *
 * @module lib/newsletter/urls
 */

const { buildMillaAuthUrl, getMillaAuthOrigin } = require('../utils/millaAuth');
const { resolveNewsletterContext } = require('../utils/brandContext');

/**
 * Build the newsletter iframe embed URL
 * @param {string} [newsletterId] - Newsletter ID (auto-detected if not provided)
 * @param {string} [location] - Widget location (default: 'sidebar')
 * @returns {string} The iframe URL
 */
function buildNewsletterIframeUrl(newsletterId, location) {
  const ctx = resolveNewsletterContext();
  const id = typeof newsletterId === 'string' && newsletterId.trim()
    ? newsletterId.trim()
    : ctx.id;
  const loc = typeof location === 'string' && location.trim()
    ? location.trim()
    : 'sidebar';
  const sourceUrl = typeof window !== 'undefined' && window.location
    ? window.location.href
    : null;

  const params = {
    newsletterId: id,
    location: loc
  };

  if (sourceUrl) {
    params.sourceUrl = sourceUrl;
  }

  return buildMillaAuthUrl('/embed/newsletter', params);
}

/**
 * Build the newsletter subscribe API URL
 * @returns {string} The subscribe endpoint URL
 */
function buildNewsletterSubscribeUrl() {
  const origin = getMillaAuthOrigin();
  return `${origin}/api/newsletter/subscribe`;
}

/**
 * Build the newsletter preview URL based on current context
 * @returns {string} The preview URL for the current newsletter
 */
function buildNewsletterPreviewUrl() {
  const ctx = resolveNewsletterContext();
  const origin = getMillaAuthOrigin(ctx.defaultBaseUrl);
  return `${origin}/newsletter/${ctx.previewSlug}/preview`;
}

module.exports = {
  buildNewsletterIframeUrl,
  buildNewsletterSubscribeUrl,
  buildNewsletterPreviewUrl
};
